import { call, put, takeEvery } from 'redux-saga/effects';
import { delNote } from '../../requests/add_note_request';
import { getLeadProfileWithNotes } from '../../requests/get_lead_profile_request';

function* delLeadNote({ payload }) {
    yield put({
        type: 'SET_LEAD_NOTES_DATA',
        payload: {
            loading: true,
        },
    });

    const { leadId, noteId } = payload;
    const res = yield call(delNote, leadId, noteId);

    if (res.result) {
        const leadRes = yield call(getLeadProfileWithNotes, leadId);
        yield put({
            type: 'SET_LEAD_NOTES_DATA',
            payload: {
                loading: false,
                notes: leadRes.options.notes || [],
            },
        });

        yield put({ type: 'GET_LEAD_HISTORY_REQ', leadId });
    }
}

export default function* delNoteSaga() {
    yield takeEvery('DEL_LEAD_NOTE', delLeadNote);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/delNote.saga.js